/* eslint-disable no-unused-vars */
import httpService from '@/services/httpService'

const state = {
  generalInfo: {},
  localityInfo: {},
  competitorInfo: {}
}

const mutations = {
  setGeneralInfo(state, data) {
    state.generalInfo = data
  },
  setLocalityInfo(state, data) {
    state.localityInfo = data
  },
  setCompetitorInfo(state, data) {
    state.competitorInfo = data
  },
  clearSetupData(state) {
    state.generalInfo = {}
    state.localityInfo = {}
    state.competitorInfo = {}
  }
}

const actions = {
  registerProject: async function (store, { ...form }) {
    form = JSON.stringify(form)
    const response = await httpService.post('/account-setup/register-project', { form },
      { successMessage: 'New Project Created!', raiseError: false })
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  updateProjectSettings: async function (store, { ...form }) {
    form = JSON.stringify(form)
    const response = await httpService.post('/account-setup/update-project', { form },
      { successMessage: 'Locality Info Added!', raiseError: false })
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  addCompetitor: async function (store, { ...form }) {
    form = JSON.stringify(form)
    const response = await httpService.post('/account-setup/add-competitor', { form },
      { successMessage: 'Competitor Added!', raiseError: false })
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  completeSetup: async function (store, { ...form }) {
    form = JSON.stringify(form)
    const response = await httpService.post('/account-setup/complete-setup', { form },
      { successMessage: 'Project Setup Complete!', raiseError: false })
    if (!response || !response.data) {
      return {}
    }
    return response.data
  },
  loadChecklist: async function (store, clientId) {
    const response = await httpService.get(`/account-setup/checklist/${clientId}`)
    if (!response || !response.data) {
      return {}
    }
    return response.data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
